{
  "_meta": {
    "name": "DSA FX-share dataset (adjudicated)",
    "description": "Foreign-currency share of public debt, latest actual year per country, extracted from the most recent published IMF DSA for each country (LIC-DSF and MAC SRDSF staff reports) and human-adjudicated.",
    "source_csv": "data/fx-share/proposed-corrected-dataset.csv",
    "source_csv_sha256": "56790042fa64840b9cf3ce6800ec730f35de36469352b0cf712e0c2876bd7804",
    "source_package": "SovTech/Workstreams/2026-07_DSA-FX-Share-Extraction/04-Dataset/TEA-878-adjudication-20260717/02-Proposed-Dataset (Drive)",
    "row_count": 167,
    "coverage": {
      "LIC_DSF": 64,
      "MAC_SRDSF": 103,
      "LIC_DSF_roster": 68,
      "MAC_SRDSF_roster": 123
    },
    "generated_by": "scripts/build-fx-share.mjs",
    "linear_issue": "TEA-880"
  },
  "countries": {
    "afg": {
      "valuePct": 100,
      "year": "2020",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Islamic Republic of Afghanistan: First Review Under the Under the Extended Credit Facility Arrangement and Request for Modification of Performance Criteria-Press Release; Staff Report; and Statement by the Executive Director for Islamic Republic of Afghanistan",
      "reportDate": "2021-06-28",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2021/138/002.2021.issue-138-en.xml",
      "pdfPage": "81",
      "printedPage": "6",
      "tableRef": "Table 2. Islamic Republic of Afghanistan: Public Sector Debt Sustainability Framework, Baseline Scenario, 2020–41"
    },
    "ago": {
      "valuePct": 70,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Angola: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Angola",
      "reportDate": "2026-05-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/094/002.2026.issue-094-en.xml",
      "pdfPage": "57",
      "printedPage": "52",
      "tableRef": "Annex IV, Figure 1, DSA Summary Assessment"
    },
    "alb": {
      "valuePct": 42.2,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Albania: 2025 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2025-12-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/345/002.2025.issue-345-en.xml",
      "pdfPage": "56",
      "printedPage": "50",
      "tableRef": "Annex V. Figure 3. Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "are": {
      "valuePct": 56,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "United Arab Emirates: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for United Arab Emirates",
      "reportDate": "2025-12-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/327/002.2025.issue-327-en.xml",
      "pdfPage": "42",
      "printedPage": "37",
      "tableRef": "Annex II. Table 3. United Arab Emirates: Public Debt Structure Indicators — Debt by Currency"
    },
    "arg": {
      "valuePct": 55.7,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Argentina: 2026 Article IV Consultation, Second Review under the Extended Arragnement under the Extended Fund Facility, Requests for a Waiver of Nonobservance of a Performance Criterion, Modification of Performance Criteria, and Financing Assurances Review-Press Release; Staff Report; Staff Supplement; and Statement by the Executive Director for Argentina",
      "reportDate": "2026-05-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/105/002.2026.issue-105-en.xml",
      "pdfPage": "79",
      "printedPage": "75",
      "tableRef": "Table 4. Argentina: Public Debt Structure Indicators"
    },
    "arm": {
      "valuePct": 48.8,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Republic of Armenia: First Review Under the Stand-By Arrangement, Request for  Modification of Performance Criteria and Monetary Policy Consultation Clause-Press Release; and Staff Report",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/132/002.2026.issue-132-en.xml",
      "pdfPage": "25",
      "printedPage": "21",
      "tableRef": "Table 3a. Armenia: Central Government Operations, 2022–31"
    },
    "atg": {
      "valuePct": 35.1,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Antigua and Barbuda: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Antigua and Barbuda",
      "reportDate": "2026-05-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/097/002.2026.issue-097-en.xml",
      "pdfPage": "40",
      "printedPage": "36",
      "tableRef": "Annex I. Figure 1, “Public debt structure indicators” — Debt by currency"
    },
    "aus": {
      "valuePct": 0,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Australia: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Australia",
      "reportDate": "2026-02-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/038/002.2026.issue-038-en.xml",
      "pdfPage": "55",
      "printedPage": "49",
      "tableRef": "Figure 3. Australia: Public Debt Structure Indicators, Debt by Currency (Percent of GDP)"
    },
    "aze": {
      "valuePct": 41.5,
      "year": "2023",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Republic of Azerbaijan: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for the Republic of Azerbaijan",
      "reportDate": "2025-04-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/098/002.2025.issue-098-en.xml",
      "pdfPage": "44",
      "printedPage": "38",
      "tableRef": "Figure IV.2, Azerbaijan: Public Debt Structure Indicators — Debt by Currency (In Percent of GDP)"
    },
    "bdi": {
      "valuePct": 25.8,
      "year": "2025",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "central_government",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Burundi: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Burundi",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/150/002.2026.issue-150-en.xml",
      "pdfPage": "103",
      "printedPage": "15",
      "tableRef": "Table 1. Burundi: Decomposition of Public Debt and Debt Service by Creditor, 2024-26"
    },
    "bel": {
      "valuePct": 0,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Belgium: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Belgium",
      "reportDate": "2026-02-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/049/002.2026.issue-049-en.xml",
      "pdfPage": "55",
      "printedPage": "49",
      "tableRef": "Figure III.3. Belgium: Public Debt Structure Indicators, Debt by Currency (Percent of GDP)"
    },
    "ben": {
      "valuePct": 78.3,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Benin: Seventh Reviews Under the Extended Fund Facility and the Extended Credit Facility Arrangements and Fourth Review Under the Resilience and Sustainability Facility Arrangement-Press Release; Staff Report; and Statement by the Executive Director for Benin",
      "reportDate": "2026-04-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/086/002.2026.issue-086-en.xml",
      "pdfPage": "100",
      "printedPage": "9",
      "tableRef": "Table 1. Benin: Decomposition of Public Debt and Debt Service by Creditor, 2024–26"
    },
    "bfa": {
      "valuePct": 44.6,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Burkina Faso: Fourth Review Under the Extended Credit Facility Arrangement, Financing Assurances Review, and Request for an Arrangement Under the Resilience and Sustainability Facility-Press Release; Staff Report; and Statement by the Executive Director for Burkina Faso",
      "reportDate": "2026-03-23",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/064/002.2026.issue-064-en.xml",
      "pdfPage": "136",
      "printedPage": "16",
      "tableRef": "Table 3. Burkina Faso: Public Debt Sustainability Framework, Baseline Scenario, 2022–2045"
    },
    "bgd": {
      "valuePct": 46.3,
      "year": "FY25",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Bangladesh: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Bangladesh",
      "reportDate": "2026-01-30",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/024/002.2026.issue-024-en.xml",
      "pdfPage": "87",
      "printedPage": "22",
      "tableRef": "Table 2. Bangladesh: Public Sector Debt Sustainability Framework, Baseline Scenario, FY23–FY46"
    },
    "bgr": {
      "valuePct": 70.8,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Bulgaria: 2025 Article IV Consultation-Press Release; Staff Report; and Staff Supplement",
      "reportDate": "2025-11-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/306/002.2025.issue-306-en.xml",
      "pdfPage": "49",
      "printedPage": "44",
      "tableRef": "Annex III. Figure 2: Bulgaria: Public Debt Structure Indicators"
    },
    "bhs": {
      "valuePct": 47.6,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "The Bahamas: 2024 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for The Bahamas",
      "reportDate": "2025-01-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/008/002.2025.issue-008-en.xml",
      "pdfPage": "51",
      "printedPage": "46",
      "tableRef": "Annex V. Figure 2. The Bahamas: Public Debt Structure Indicators"
    },
    "bih": {
      "valuePct": 66.1,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Bosnia and Herzegovina: 2025 Article IV Consultation-Press Release; Staff Report; Staff Supplement; and Statement  by the Alternate Executive Director for Bosnia and Herzegovina",
      "reportDate": "2025-09-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/252/002.2025.issue-252-en.xml",
      "pdfPage": "58",
      "printedPage": "53",
      "tableRef": "Annex VI. Figure 3. Bosnia and Herzegovina: Public Debt Structure Indicators — Debt by Currency"
    },
    "blz": {
      "valuePct": 63.1,
      "year": "2023",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Belize: 2024 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2024-05-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2024/124/002.2024.issue-124-en.xml",
      "pdfPage": "46",
      "printedPage": "41",
      "tableRef": "Figure 2. Belize: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "bol": {
      "valuePct": 31.6,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "nfps",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Bolivia: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Bolivia",
      "reportDate": "2025-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/116/002.2025.issue-116-en.xml",
      "pdfPage": "52",
      "printedPage": "47",
      "tableRef": "Table 3. Bolivia: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "bra": {
      "valuePct": 5.2,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Brazil: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Brazil",
      "reportDate": "2025-07-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/194/002.2025.issue-194-en.xml",
      "pdfPage": "5",
      "printedPage": "4",
      "tableRef": "Table 1. Brazil: Selected Economic Indicators, 2023–30"
    },
    "brb": {
      "valuePct": 40,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Barbados: 2026 Article IV Consultation and Request for a Stand-By Arrangement-Press Release; Staff Report; and Statement by the Executive Director for Barbados",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/155/002.2026.issue-155-en.xml",
      "pdfPage": "64",
      "printedPage": "59",
      "tableRef": "Annex II. Figure 2. Barbados: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "btn": {
      "valuePct": 91,
      "year": "FY2024/25",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "public_sector",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Bhutan: 2025 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2026-01-27",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/019/002.2026.issue-019-en.xml",
      "pdfPage": "56",
      "printedPage": "3",
      "tableRef": "Paragraph 3 and Composition of Outstanding PPG Debt"
    },
    "bwa": {
      "valuePct": 38.7,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Botswana: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Botswana",
      "reportDate": "2025-12-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/325/002.2025.issue-325-en.xml",
      "pdfPage": "43",
      "printedPage": "37",
      "tableRef": "Figure 3. Botswana: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "caf": {
      "valuePct": 52.7,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "general_government",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Central African Republic: Third and Fourth Review Under the Extended Credit Facility, Requests for a Waiver of Nonobservance of Performance Criteria, and Financing Assurance Review",
      "reportDate": "2025-06-23",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/140/002.2025.issue-140-en.xml",
      "pdfPage": "117",
      "printedPage": "22",
      "tableRef": "Table 3. Central African Republic: Public Sector Debt Sustainability Framework, Baseline Scenario, 2022-2045"
    },
    "can": {
      "valuePct": 5.5,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Canada: 2025 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2026-01-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/012/002.2026.issue-012-en.xml",
      "pdfPage": "59",
      "printedPage": "53",
      "tableRef": "Annex III. Figure 3. Canada: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "chl": {
      "valuePct": 35,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Chile: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Chile",
      "reportDate": "2026-07-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/169/002.2026.issue-169-en.xml",
      "pdfPage": "57",
      "printedPage": "53",
      "tableRef": "Table 3. Chile: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "civ": {
      "valuePct": 63.8,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Côte d’Ivoire: Fourth Reviews Under the Extended Arrangement Under the Extended Fund Facility and the Arrangement Under the Extended Credit Facility, Request for Modification of a Quantitative Performance Criterion, and Third Review Under the Resilience and Sustainability Facility Arrangement-Press Release; Staff Report; and Statement by the Executive Director for Côte d’Ivoire",
      "reportDate": "2025-07-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/218/002.2025.issue-218-en.xml",
      "pdfPage": "155",
      "printedPage": "18",
      "tableRef": "Table 5. Côte d’Ivoire: Public Sector Debt Sustainability Framework, Baseline Scenario, 2022–45"
    },
    "cmr": {
      "valuePct": 65.4,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "public_sector",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Cameroon: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Cameroon",
      "reportDate": "2026-04-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/081/002.2026.issue-081-en.xml",
      "pdfPage": "87",
      "printedPage": "21",
      "tableRef": "Table 2. Cameroon: Public Sector Debt Sustainability Framework, Baseline Scenario, 2022-45"
    },
    "cod": {
      "valuePct": 64.4,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "public_sector",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Democratic Republic of the Congo: First Review Under the Extended Credit Facility Arrangement, Requests for Waivers of Nonobservance of Performance Criteria, Modification of Quantitative Performance Criteria, and Financing Assurances Review -Press Release; Staff Report; and Statement by the Executive Director for the Democratic Republic of the Congo",
      "reportDate": "2025-07-16",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/195/002.2025.issue-195-en.xml",
      "pdfPage": "142",
      "printedPage": "23",
      "tableRef": "Table 2. Democratic Republic of the Congo: Public Sector Debt Sustainability Framework, Baseline Scenario 2022-45"
    },
    "cog": {
      "valuePct": 39.8,
      "year": "2023",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Republic of Congo: Sixth Review Under the Three-Year Arrangement Under the Extended Credit Facility, Request for Waivers of Nonobservance of Performance Criteria, and Financing Assurances Review",
      "reportDate": "2025-03-24",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/075/002.2025.issue-075-en.xml",
      "pdfPage": "132",
      "printedPage": "34",
      "tableRef": "Table 3. Republic of Congo: Public Sector Debt Sustainability Framework, Baseline Scenario, 2021–44"
    },
    "col": {
      "valuePct": 47.1,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "nfps",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Colombia: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Colombia",
      "reportDate": "2025-09-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/280/002.2025.issue-280-en.xml",
      "pdfPage": "61",
      "printedPage": "55",
      "tableRef": "Figure 3. Colombia: Public Debt Structure Indicators"
    },
    "cpv": {
      "valuePct": 64.3,
      "year": "2023",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "public_sector",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Cabo Verde: Fifth Review Under the Extended Credit Facility Arrangement, Request for a Waiver of Nonobservance of Quantitative Performance Criterion, Modification of Quantitative Performance Criteria, and Second Review Under the Resilience and Sustainability Facility Arrangement-Press Release; Staff Report; and Statement by the Executive Director for Cabo Verde",
      "reportDate": "2025-02-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/043/002.2025.issue-043-en.xml",
      "pdfPage": "115",
      "printedPage": "25",
      "tableRef": "Table 3. Cabo Verde: Public Sector Debt Sustainability Framework, Baseline Scenario, 2021-44"
    },
    "cri": {
      "valuePct": 35,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Costa Rica: Report for the 2026 Article IV Consultation and Review under the Flexible Credit Line Arrangement-Press Release; Staff Report; Informational Annex; and Statement by the Executive Director for Costa Rica",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/116/002.2026.issue-116-en.xml",
      "pdfPage": "66",
      "printedPage": "60",
      "tableRef": "Figure 2. Costa Rica: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "cyp": {
      "valuePct": 0,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Cyprus: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Cyprus",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/145/002.2026.issue-145-en.xml",
      "pdfPage": "43",
      "printedPage": "39",
      "tableRef": "Table I.1. Cyprus: Risk of Sovereign Stress — DSA Summary Assessment"
    },
    "cze": {
      "valuePct": 5.9,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Czech Republic: 2026 Article IV Consultation-Press Release; Staff Report; Staff Supplement; and Statement by the Executive Director for the Czech Republic",
      "reportDate": "2026-03-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/070/002.2026.issue-070-en.xml",
      "pdfPage": "61",
      "printedPage": "55",
      "tableRef": "Figure 3. Public Debt Structure Indicators — Debt by Currency"
    },
    "deu": {
      "valuePct": 0,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Germany: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Germany",
      "reportDate": "2026-02-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/036/002.2026.issue-036-en.xml",
      "pdfPage": "67",
      "printedPage": "62",
      "tableRef": "Annex II. Figure 3. Germany: Public Debt Structure Indicators, Debt by Currency (Percent of GDP)"
    },
    "dji": {
      "valuePct": 100,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "central_government",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Djibouti: 2025 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2025-09-22",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/276/002.2025.issue-276-en.xml",
      "pdfPage": "63",
      "printedPage": "12",
      "tableRef": "Table 2. Djibouti: Public Sector Debt Sustainability Framework, Baseline Scenario, 2022–2045"
    },
    "dma": {
      "valuePct": 66.8,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "central_government",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Dominica: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Dominica",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/117/002.2026.issue-117-en.xml",
      "pdfPage": "82",
      "printedPage": "15",
      "tableRef": "Table 3. Dominica: Public Sector Debt Sustainability Framework, 2022–45"
    },
    "dom": {
      "valuePct": 56.8,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Dominican Republic: 2025 Article IV Consultation-Press Release; Staff Report and Statement by the Executive Director for Dominican Republic",
      "reportDate": "2025-11-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/305/002.2025.issue-305-en.xml",
      "pdfPage": "56",
      "printedPage": "50",
      "tableRef": "Figure 3. Public Debt Structure Indicators — Debt by Currency"
    },
    "dza": {
      "valuePct": 1,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Algeria: 2025 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2025-09-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/270/002.2025.issue-270-en.xml",
      "pdfPage": "61",
      "printedPage": "54",
      "tableRef": "Annex IV. Figure 3. Algeria: Public Debt Structure Indicators — commentary"
    },
    "ecu": {
      "valuePct": 0,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "nfps",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Ecuador: Fifth Review Under the Extended Arrangement Under the Extended Fund Facility, Requests for Waivers of Nonobservance of Performance Criteria, Modification of Performance Criteria, and Financing Assurances Review-Press Release; Staff Report; and Statement by the Executive Director for Ecuador",
      "reportDate": "2026-04-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/084/002.2026.issue-084-en.xml",
      "pdfPage": "64",
      "printedPage": "59",
      "tableRef": "Figure 3. Ecuador: Public Debt Structure Indicators, Debt by Currency (Percent of GDP)"
    },
    "egy": {
      "valuePct": 35.9,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Arab Republic of Egypt: Fifth and Sixth Reviews Under the Extended Arrangement Under the Extended Fund Facility and First Review Under the Resilience and Sustainability Arrangement, Requests for Rephasing of Access, Extension of the Arrangements, Waiver of Nonobservance of Performance Criterion, and Modification of Performance Criteria-Press Release; and Staff Report",
      "reportDate": "2026-03-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/069/002.2026.issue-069-en.xml",
      "pdfPage": "56",
      "printedPage": "51",
      "tableRef": "Figure 3. Egypt: Public Debt Structure Indicators — Debt by Currency"
    },
    "esp": {
      "valuePct": 0,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Spain: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Spain",
      "reportDate": "2026-05-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/102/002.2026.issue-102-en.xml",
      "pdfPage": "68",
      "printedPage": "63",
      "tableRef": "Annex III. Figure 3. Spain: Public Debt Coverage Structure Indicators — Debt by Currency"
    },
    "est": {
      "valuePct": 0,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Republic of Estonia: 2025 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2025-07-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/181/002.2025.issue-181-en.xml",
      "pdfPage": "59",
      "printedPage": "53",
      "tableRef": "Annex III. Figure 3. Estonia: Public Debt Structure Indicators, Debt by Currency (Percent of GDP)"
    },
    "fin": {
      "valuePct": 2.3,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Finland: 2026 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2026-01-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/006/002.2026.issue-006-en.xml",
      "pdfPage": "43",
      "printedPage": "37",
      "tableRef": "Figure I.3. Finland: Public Debt Structure Indicators, Debt by Currency (Percent of GDP)"
    },
    "fji": {
      "valuePct": 35,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Republic of Fiji: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Republic of Fiji",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/118/002.2026.issue-118-en.xml",
      "pdfPage": "45",
      "printedPage": "41",
      "tableRef": "Annex III. Figure 1. Fiji: Public Debt Structure Indicators — Debt by Currency"
    },
    "fsm": {
      "valuePct": 94.3,
      "year": "Jun-23",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "general_government",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Federated States of Micronesia: 2023 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Federated States of Micronesia",
      "reportDate": "2024-03-04",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2024/066/002.2024.issue-066-en.xml",
      "pdfPage": "64",
      "printedPage": "3",
      "tableRef": "Text Table 2. Stock of Debt Owed by the National and State Governments"
    },
    "gab": {
      "valuePct": 52.3,
      "year": "2023",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Gabon: 2024 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Gabon",
      "reportDate": "2024-05-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2024/144/002.2024.issue-144-en.xml",
      "pdfPage": "54",
      "printedPage": "49",
      "tableRef": "Figure IV.3. Gabon: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "gbr": {
      "valuePct": 0,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "United Kingdom: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for United Kingdom",
      "reportDate": "2026-07-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/172/002.2026.issue-172-en.xml",
      "pdfPage": "60",
      "printedPage": "55",
      "tableRef": "Figure V.3. United Kingdom: Public Debt Structure Indicators"
    },
    "geo": {
      "valuePct": 67.6,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Georgia: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Georgia",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/133/002.2026.issue-133-en.xml",
      "pdfPage": "44",
      "printedPage": "40",
      "tableRef": "Figure 2. Georgia: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "gha": {
      "valuePct": 53,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "central_government",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Ghana: Fifth Review Under the Arrangement Under the Extended Credit Facility, Requests for Modification of the Monetary Policy Consultation Clause and Program Extension, and Financing Assurances Review-Press Release; Staff Report; and Statement by the Executive Director for Ghana",
      "reportDate": "2025-12-22",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/343/002.2025.issue-343-en.xml",
      "pdfPage": "104",
      "printedPage": "5",
      "tableRef": "Text Table 2. Ghana: Decomposition of Public Debt at end-2024 (Residency basis)"
    },
    "gin": {
      "valuePct": 48.9,
      "year": "2023",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Guinea: 2024 Article IV Consultation and Request for Disbursement Under the Rapid Credit Facility-Press Release; Staff Report; and Statement by the Executive Director for Guinea",
      "reportDate": "2024-05-17",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2024/130/002.2024.issue-130-en.xml",
      "pdfPage": "98",
      "printedPage": "14",
      "tableRef": "Table 2. Guinea: Public Sector Debt Sustainability Framework, Baseline Scenario, 2021–44"
    },
    "gmb": {
      "valuePct": 63.8,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "The Gambia: Fourth Review Under the Extended Credit Facility Arrangement, Requests for a Waiver of Nonobservance of a Performance Criterion, Modifications of Performance Criteria and Indicative Targets, and Financing Assurances Review; First Review Under the Resilience and Sustainability Facility Arrangement, and Request for Rephasing of Access-Press Release; Staff Report; and Statement by the Executive Director for The Gambia",
      "reportDate": "2025-12-23",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/344/002.2025.issue-344-en.xml",
      "pdfPage": "97",
      "printedPage": "17",
      "tableRef": "Table 3. The Gambia: Public Sector Debt Sustainability Framework, Baseline Scenario, 2022–2045"
    },
    "gnb": {
      "valuePct": 37.7,
      "year": "2025",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Guinea-Bissau: Eleventh Review Under the Extended Credit Facility Arrangement, Requests for Modification of Performance Criteria and Financing Assurances Review",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/140/002.2026.issue-140-en.xml",
      "pdfPage": "82",
      "printedPage": "24",
      "tableRef": "Table 2. Guinea-Bissau: Public Sector Debt Sustainability Framework, Baseline Scenario, 2023–46"
    },
    "gnq": {
      "valuePct": 21.4,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Republic of Equatorial Guinea: Staff Report for the 2025 Article IV Consultation and First and Second Reviews Under the Staff-Monitored Program-Press Release; Staff Report; and Statement by the Executive Director for the Republic of Equatorial Guinea",
      "reportDate": "2025-08-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/224/002.2025.issue-224-en.xml",
      "pdfPage": "53",
      "printedPage": "46",
      "tableRef": "Table 3. Equatorial Guinea: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "grc": {
      "valuePct": 0,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Greece: 2026 Article IV Consultation - Press Release; Staff Report; and Statement by the Executive Director for Greece",
      "reportDate": "2026-05-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/108/002.2026.issue-108-en.xml",
      "pdfPage": "44",
      "printedPage": "40",
      "tableRef": "Figure 3. Greece: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "grd": {
      "valuePct": 73.8,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Grenada: 2025 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2026-01-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/009/002.2026.issue-009-en.xml",
      "pdfPage": "67",
      "printedPage": "3",
      "tableRef": "Text Table 3. Grenada: Public Sector Debt, 2021–2024; footnote 7"
    },
    "gtm": {
      "valuePct": 46.8,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Guatemala: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Guatemala",
      "reportDate": "2025-09-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/260/002.2025.issue-260-en.xml",
      "pdfPage": "59",
      "printedPage": "54",
      "tableRef": "Figure 1. Guatemala: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "hnd": {
      "valuePct": 57.8,
      "year": "2023",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Honduras: First and Second Reviews Under the Extended Fund Facility and the Extended Credit Facility Arrangements, and Requests for Waivers of Nonobservance of Performance Criteria and Rephasing of Purchases-Press Release; Staff Report; and Statement by the Executive Director for Honduras",
      "reportDate": "2024-12-10",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2024/332/002.2024.issue-332-en.xml",
      "pdfPage": "117",
      "printedPage": "16",
      "tableRef": "Table 2. Honduras: Public Debt Sustainability Framework, Baseline Scenario, 2021–44"
    },
    "hrv": {
      "valuePct": 0,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Republic of Croatia: 2025 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2025-12-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/329/002.2025.issue-329-en.xml",
      "pdfPage": "51",
      "printedPage": "45",
      "tableRef": "Annex I. Figure 3. Croatia: Public Debt Structure Indicators, Debt by Currency (Percent of GDP)"
    },
    "hti": {
      "valuePct": 14.6,
      "year": "FY2024",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "general_government",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Haiti: Second Review Under the Staff-Monitored Program and Request for Extension-Press Release; and Staff Report",
      "reportDate": "2025-12-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/337/002.2025.issue-337-en.xml",
      "pdfPage": "110",
      "printedPage": "20",
      "tableRef": "Table 4. Haiti: Public Sector Debt Sustainability Framework, Baseline Scenario, 2022–2045"
    },
    "hun": {
      "valuePct": 31.3,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Hungary: 2025 Article IV Consultation-Press Release; Staff Report; and Statement  by the Executive Director for Hungary",
      "reportDate": "2025-08-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/250/002.2025.issue-250-en.xml",
      "pdfPage": "56",
      "printedPage": "51",
      "tableRef": "Annex VI. Table 3. Hungary: Public Debt Structure Indicators — Debt by Currency"
    },
    "idn": {
      "valuePct": 28.5,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Indonesia: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Indonesia",
      "reportDate": "2026-01-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/010/002.2026.issue-010-en.xml",
      "pdfPage": "49",
      "printedPage": "43",
      "tableRef": "Table 2. Indonesia: Selected Vulnerability Indicators, 2021-25"
    },
    "irl": {
      "valuePct": 0,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Ireland: 2026 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/156/002.2026.issue-156-en.xml",
      "pdfPage": "50",
      "printedPage": "44",
      "tableRef": "Annex V. Figure 3 — Debt by Currency (Percent of GDP)"
    },
    "irq": {
      "valuePct": 42.4,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Iraq: 2025 Article IV Consultation-Press Release; Staff Report; and Informational Annex",
      "reportDate": "2025-07-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/183/002.2025.issue-183-en.xml",
      "pdfPage": "45",
      "printedPage": "39",
      "tableRef": "Figure 2. Iraq: Public Debt Structure Indicators — Debt by Currency"
    },
    "isl": {
      "valuePct": 9.8,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Iceland: 2025 Article IV Consultation-Press Release; Staff Report and Statement by the Executive Director for Iceland",
      "reportDate": "2025-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/141/002.2025.issue-141-en.xml",
      "pdfPage": "48",
      "printedPage": "43",
      "tableRef": "Annex III. Figure 2. Iceland: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "isr": {
      "valuePct": 14.7,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Israel: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Alternate Executive Director for Israel",
      "reportDate": "2026-07-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/161/002.2026.issue-161-en.xml",
      "pdfPage": "58",
      "printedPage": "54",
      "tableRef": "Annex VI. Figure 2. Israel: Public Debt Structure Indicators — Debt by Currency"
    },
    "ita": {
      "valuePct": 0,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Italy: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Italy",
      "reportDate": "2025-07-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/201/002.2025.issue-201-en.xml",
      "pdfPage": "54",
      "printedPage": "48",
      "tableRef": "Annex II. Figure 2. Italy: Public Debt Structure Indicators, Debt by Currency (Percent of GDP)"
    },
    "jam": {
      "valuePct": 64.5,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Jamaica: Request for Purchase Under the Rapid Financing Instrument-Press Release; Staff Report; and Statement by the Executive Director for Jamaica",
      "reportDate": "2026-01-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/008/002.2026.issue-008-en.xml",
      "pdfPage": "34",
      "printedPage": "29",
      "tableRef": "Figure 2. Jamaica: Public Debt Structure Indicators (Fiscal Year) — Debt by Currency"
    },
    "jor": {
      "valuePct": 39.8,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Jordan: Fifth Review Under the Extended Arrangement Under the Extended Fund Facility, Request for Modification of Performance Criteria, and Second Review Under the Resilience and Sustainability Facility Arrangement-Press Release; Staff Report; and Statement by the Executive Director for Jordan",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/146/002.2026.issue-146-en.xml",
      "pdfPage": "57",
      "printedPage": "53",
      "tableRef": "Annex III. Figure 1. Jordan: Public Debt Structure Indicators — Debt by Currency"
    },
    "jpn": {
      "valuePct": 0,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Japan: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Japan",
      "reportDate": "2026-04-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/075/002.2026.issue-075-en.xml",
      "pdfPage": "62",
      "printedPage": "57",
      "tableRef": "Figure 3. Japan: Public Debt Structure Indicators, Debt by Currency (Percent of GDP)"
    },
    "kaz": {
      "valuePct": 26.2,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Republic of Kazakhstan: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for the Republic of Kazakhstan",
      "reportDate": "2026-01-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/017/002.2026.issue-017-en.xml",
      "pdfPage": "51",
      "printedPage": "46",
      "tableRef": "Figure 3. Kazakhstan: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "ken": {
      "valuePct": 55.3,
      "year": "2023",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Kenya: Seventh and Eighth Reviews Under the Extended Fund Facility and Extended Credit Facility Arrangements, Requests for Reduction of Access, Augmentation and Rephasing of Access Under the Arrangements, Modifications of Performance Criteria, Waiver of Nonobservance of Performance Criteria, and Review Under the Resilience and Sustainability Facility Arrangement-Press Release; Staff Report; and Statement by the Executive Director for Kenya",
      "reportDate": "2024-11-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2024/316/002.2024.issue-316-en.xml",
      "pdfPage": "158",
      "printedPage": "26",
      "tableRef": "Table 2. Kenya: Public Sector Debt Sustainability Framework, Baseline Scenario, 2021–44"
    },
    "kgz": {
      "valuePct": 72.7,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Kyrgyz Republic: 2025 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2025-06-04",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/118/002.2025.issue-118-en.xml",
      "pdfPage": "43",
      "printedPage": "38",
      "tableRef": "Figure 1. Public debt: 2014–2024"
    },
    "khm": {
      "valuePct": 99.2,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Cambodia: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Cambodia",
      "reportDate": "2025-12-02",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/317/002.2025.issue-317-en.xml",
      "pdfPage": "87",
      "printedPage": "16",
      "tableRef": "Table 2. Cambodia: Public Sector Debt Sustainability Framework, Baseline Scenario, 2022–2045"
    },
    "kir": {
      "valuePct": 98.8,
      "year": "2025",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "general_government",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Kiribati: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Kiribati",
      "reportDate": "2026-05-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/099/002.2026.issue-099-en.xml",
      "pdfPage": "12",
      "printedPage": "7",
      "tableRef": "Paragraph 7, public debt composition"
    },
    "kna": {
      "valuePct": 19,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "nfps",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "St. Kitts and Nevis: 2026 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2026-05-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/093/002.2026.issue-093-en.xml",
      "pdfPage": "65",
      "printedPage": "60",
      "tableRef": "Figure 3. St. Kitts and Nevis: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "kor": {
      "valuePct": 1.4,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Republic of Korea: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Republic of Korea",
      "reportDate": "2025-11-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/308/002.2025.issue-308-en.xml",
      "pdfPage": "57",
      "printedPage": "52",
      "tableRef": "Figure 3. Republic of Korea: Public Debt Structure Indicators, Debt by Currency (Percent of GDP)"
    },
    "kwt": {
      "valuePct": 82.8,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Kuwait: 2025 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2026-02-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/052/002.2026.issue-052-en.xml",
      "pdfPage": "48",
      "printedPage": "42",
      "tableRef": "Figure 3. Kuwait: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "lao": {
      "valuePct": 90.4,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Lao People's Democratic Republic: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Lao People’s Democratic Republic",
      "reportDate": "2026-02-20",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/050/002.2026.issue-050-en.xml",
      "pdfPage": "101",
      "printedPage": "24",
      "tableRef": "Table 2. Lao PDR: Public Sector Debt Sustainability Framework, Baseline Scenario, 2022–2044"
    },
    "lbn": {
      "valuePct": 97.7,
      "year": "2023",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Lebanon: 2023 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Lebanon",
      "reportDate": "2023-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2023/237/002.2023.issue-237-en.xml",
      "pdfPage": "45",
      "printedPage": "40",
      "tableRef": "Lebanon: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "lbr": {
      "valuePct": 65.2,
      "year": "2025",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "central_government",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Liberia: Third Review Under the Extended Credit Facility Arrangement and Request for an Arrangement Under the Resilience and Sustainability Facility-Press Release; Staff Report; and Statement by the Executive Director for Liberia",
      "reportDate": "2026-05-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/098/002.2026.issue-098-en.xml",
      "pdfPage": "140",
      "printedPage": "5",
      "tableRef": "Text Table 3. Decomposition of Public Debt and Debt Service by Creditor, 2024–25"
    },
    "lca": {
      "valuePct": 39.5,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "St. Lucia: 2025 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2026-01-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/003/002.2026.issue-003-en.xml",
      "pdfPage": "56",
      "printedPage": "49",
      "tableRef": "Annex VI. Table 3. St. Lucia: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "lka": {
      "valuePct": 40,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Sri Lanka: Fifth and Sixth Reviews under the Extended Arrangement under the Extended Fund Facility, Requests for a Waiver of nonobservance of a Performance Criterion, Modification of Performance Criteria, and Financing Assurances Review-Press Release; Staff Report; and Statement by the Executive Director for Sri Lanka",
      "reportDate": "2026-05-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/111/002.2026.issue-111-en.xml",
      "pdfPage": "50",
      "printedPage": "46",
      "tableRef": "Figure 3. Sri Lanka: Public Debt Structure Indicators — Debt by Currency"
    },
    "lso": {
      "valuePct": 80.3,
      "year": "FY2024/25",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Kingdom of Lesotho: 2025 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2025-09-18",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/267/002.2025.issue-267-en.xml",
      "pdfPage": "84",
      "printedPage": "16",
      "tableRef": "Table 3. Lesotho: Public Sector Debt Sustainability Framework, Baseline Scenario, 2022–45"
    },
    "ltu": {
      "valuePct": 0,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Republic of Lithuania: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for the Republic of Lithuania",
      "reportDate": "2025-09-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/258/002.2025.issue-258-en.xml",
      "pdfPage": "58",
      "printedPage": "52",
      "tableRef": "Annex VII. Table 3. Lithuania: Public Debt Structure Indicators, Debt by Currency (Percent of GDP)"
    },
    "lux": {
      "valuePct": 0,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Luxembourg: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Luxembourg",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/159/002.2026.issue-159-en.xml",
      "pdfPage": "53",
      "printedPage": "48",
      "tableRef": "Annex IV. Figure 3. Luxembourg: Public Debt Structure Indicators, Debt by Currency (Percent of GDP)"
    },
    "lva": {
      "valuePct": 9.5,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Republic of Latvia: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for the Republic of Latvia",
      "reportDate": "2025-09-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/272/002.2025.issue-272-en.xml",
      "pdfPage": "51",
      "printedPage": "45",
      "tableRef": "Annex III. Figure 3. Public Debt Structure Indicators — Debt by Currency"
    },
    "mar": {
      "valuePct": 28.5,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Morocco: 2026 Article IV Consultation and Review Under the Flexible Credit Line Arrangement-Press Release; Staff Report; and Statement by the Executive Director for Morocco",
      "reportDate": "2026-03-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/072/002.2026.issue-072-en.xml",
      "pdfPage": "76",
      "printedPage": "65",
      "tableRef": "Annex IV. Figure 3. Morocco: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "mda": {
      "valuePct": 63.4,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "public_sector",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Republic of Moldova: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Alternate Executive Director for Republic of Moldova",
      "reportDate": "2026-03-05",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/059/002.2026.issue-059-en.xml",
      "pdfPage": "79",
      "printedPage": "5",
      "tableRef": "Text Table 2. Decomposition of Public Debt and Debt Service by Creditor"
    },
    "mdg": {
      "valuePct": 71.7,
      "year": "2023",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Republic of Madagascar: Staff Report for the 2024 Article IV Consultation; First Review Under the Extended Credit Facility Arrangement; Request for A Waiver of Nonobservance of Performance Criteria; and Financing Assurances Review; and First Review Under the Arrangement Under the Resilience and Sustainability Facility-Press Release; Staff Report; and Statement by the Executive Director for Republic of Madagascar",
      "reportDate": "2025-03-21",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/060/002.2025.issue-060-en.xml",
      "pdfPage": "167",
      "printedPage": "14",
      "tableRef": "Table 2. Madagascar: Public Sector Debt Sustainability Framework, Baseline Scenario, 2021–2044"
    },
    "mdv": {
      "valuePct": 44.6,
      "year": "2022",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "central_government",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Maldives: 2024 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Maldives",
      "reportDate": "2024-05-13",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2024/106/002.2024.issue-106-en.xml",
      "pdfPage": "95",
      "printedPage": "20",
      "tableRef": "Table 2. Maldives: Public Sector Debt Sustainability Framework, Baseline Scenario, 2020–2043"
    },
    "mex": {
      "valuePct": 22.3,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Mexico: Request for an Arrangement Under the Flexible Credit Line and Cancellation of the Current Arrangement-Press Release; and Staff Report",
      "reportDate": "2025-11-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/301/002.2025.issue-301-en.xml",
      "pdfPage": "30",
      "printedPage": "26",
      "tableRef": "Figure 7. Mexico: SRDSA – Public Debt Structure Indicators"
    },
    "mhl": {
      "valuePct": 100,
      "year": "FY2024",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Republic of Marshall Islands: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Authorities of the Republic of Marshall Islands",
      "reportDate": "2025-12-04",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/321/002.2025.issue-321-en.xml",
      "pdfPage": "73",
      "printedPage": "3",
      "tableRef": "Public Debt Coverage paragraph 1, corroborated by Table 2 currency-composition chart"
    },
    "mkd": {
      "valuePct": 65.7,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Republic of North Macedonia: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Republic of North Macedonia",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/123/002.2026.issue-123-en.xml",
      "pdfPage": "42",
      "printedPage": "38",
      "tableRef": "Annex II. Figure 2. North Macedonia: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "mli": {
      "valuePct": 46.7,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Mali: Request for Disbursement Under the Rapid Credit Facility and Request for a Staff-Monitored Program-Press Release; Staff Report; and Statement by the Executive Director for Mali",
      "reportDate": "2025-05-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/106/002.2025.issue-106-en.xml",
      "pdfPage": "116",
      "printedPage": "24",
      "tableRef": "Table 2. Mali: Public Debt Sustainability Framework. Baseline Scenario, 2022–45"
    },
    "mlt": {
      "valuePct": 0,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Malta: 2025 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2026-02-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/029/002.2026.issue-029-en.xml",
      "pdfPage": "55",
      "printedPage": "50",
      "tableRef": "Annex VI. Figure 3. Malta: Public Debt Structure Indicators, Debt by Currency (Percent of GDP)"
    },
    "mmr": {
      "valuePct": 39.5,
      "year": "Jun-20",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "public_sector",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Myanmar: Requests for Disbursement Under the Rapid Credit Facility and Purchase Under the Rapid Financing Instrument-Press Release; Staff Report; and Statement by the Executive Director for Myanmar",
      "reportDate": "2021-01-28",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2021/023/002.2021.issue-023-en.xml",
      "pdfPage": "40",
      "printedPage": "3",
      "tableRef": "Text Table 1. Total Public and Publicly Guaranteed Debt"
    },
    "mne": {
      "valuePct": 13.2,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Montenegro: 2025 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2025-11-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/304/002.2025.issue-304-en.xml",
      "pdfPage": "66",
      "printedPage": "60",
      "tableRef": "Annex VII. Figure 3. Montenegro: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "mng": {
      "valuePct": 94,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Mongolia: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Alternate Executive Director for Mongolia",
      "reportDate": "2025-09-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/265/002.2025.issue-265-en.xml",
      "pdfPage": "53",
      "printedPage": "48",
      "tableRef": "Annex IV, paragraphs 2-4, Figure 3 discussion"
    },
    "moz": {
      "valuePct": 67.7,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Republic of Mozambique: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Mozambique",
      "reportDate": "2026-02-19",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/045/002.2026.issue-045-en.xml",
      "pdfPage": "84",
      "printedPage": "16",
      "tableRef": "Table 2. Mozambique: Public Sector Sustainability Framework, Under Unchanged Policies, 2022–2045"
    },
    "mrt": {
      "valuePct": 84.8,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "central_government",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Islamic Republic of Mauritania: Fifth Reviews Under the Arrangements Under the Extended Credit Facility and the Extended Fund Facility, Request for a Waiver of Applicability of Performance Criteria, and Fourth Review Under the Arrangement Under the Resilience and Sustainability Facility-Press Release; Staff Report; and Statement by the Executive Director for the Islamic Republic of Mauritania",
      "reportDate": "2026-02-05",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/027/002.2026.issue-027-en.xml",
      "pdfPage": "49",
      "printedPage": "42",
      "tableRef": "Table 10. Mauritania: Decomposition of Public Debt and Debt Service by Creditor, 2024-26"
    },
    "mus": {
      "valuePct": 20,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "nfps",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Mauritius: 2026 Article IV Consultation-Press Release; Staff Report; Staff Supplement; and Statement by the Executive Director for Mauritius",
      "reportDate": "2026-07-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/178/002.2026.issue-178-en.xml",
      "pdfPage": "49",
      "printedPage": "45",
      "tableRef": "Figure 3. Mauritius: Public Debt Structure Indicators — Debt by Currency (in percent of GDP)"
    },
    "mwi": {
      "valuePct": 42.7,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "central_government",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Malawi: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Malawi",
      "reportDate": "2025-08-06",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/226/002.2025.issue-226-en.xml",
      "pdfPage": "106",
      "printedPage": "21",
      "tableRef": "Table 2. Malawi: Public Sector Debt Sustainability Framework, Baseline Scenario, 2022-45"
    },
    "mys": {
      "valuePct": 2,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Malaysia: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Malaysia",
      "reportDate": "2026-02-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/055/002.2026.issue-055-en.xml",
      "pdfPage": "60",
      "printedPage": "55",
      "tableRef": "Annex VII. Figure 3. Malaysia: Public Debt Structure Indicators"
    },
    "nam": {
      "valuePct": 12,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Namibia: 2026 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/135/002.2026.issue-135-en.xml",
      "pdfPage": "23",
      "printedPage": "18",
      "tableRef": "Figure 3. Namibia: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "ner": {
      "valuePct": 56.5,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Niger: Eighth Review Under the Extended Credit Facility Arrangement, Fourth Review Under the Resilience and Sustainability Facility, Requests for Augmentation of the Extended Credit Facility Arrangement, Waiver of Nonobservance of a Performance Criterion, and Modification of Performance Criteria-Press Release; Staff Report; and Statement by the Executive Director for Niger",
      "reportDate": "2026-03-31",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/074/002.2026.issue-074-en.xml",
      "pdfPage": "128",
      "printedPage": "23",
      "tableRef": "Table 2. Niger: Public Sector Debt Sustainability Framework, Baseline Scenario, 2021–44"
    },
    "nga": {
      "valuePct": 46.8,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Nigeria: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Nigeria",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/125/002.2026.issue-125-en.xml",
      "pdfPage": "4",
      "printedPage": "3",
      "tableRef": "Table 1. Nigeria: Selected Economic and Financial Indicators, 2024–27"
    },
    "nic": {
      "valuePct": 79.8,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "public_sector",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Nicaragua: 2025 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2026-01-26",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/014/002.2026.issue-014-en.xml",
      "pdfPage": "85",
      "printedPage": "3",
      "tableRef": "Text Table 2. Nicaragua: Public and Private Debt"
    },
    "nld": {
      "valuePct": 0,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Kingdom of the Netherlands—The Netherlands: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for the Kingdom of the Netherlands—The Netherland",
      "reportDate": "2025-07-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/197/002.2025.issue-197-en.xml",
      "pdfPage": "56",
      "printedPage": "51",
      "tableRef": "Figure 3. The Netherlands: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "nor": {
      "valuePct": 38.8,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Norway: 2025 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2025-08-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/248/002.2025.issue-248-en.xml",
      "pdfPage": "43",
      "printedPage": "37",
      "tableRef": "Annex I. Figure 3. Norway: Public Debt Structure Indicators — Debt by Currency"
    },
    "npl": {
      "valuePct": 49.2,
      "year": "2025",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "general_government",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Nepal: 2026 Article IV Consultation and Seventh Review under the Extended Credit Facility Arrangement-Press Release; Staff Report; Staff Supplement; and Statement by the Executive Director for Nepal",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/127/002.2026.issue-127-en.xml",
      "pdfPage": "129",
      "printedPage": "7",
      "tableRef": "Text Table 2. Nepal: Decomposition of Public Debt and Debt Service by Creditor, 2025–27"
    },
    "nru": {
      "valuePct": 55.8,
      "year": "FY2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Republic of Nauru: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Alternate Executive Director for the Republic of Nauru",
      "reportDate": "2025-09-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/275/002.2025.issue-275-en.xml",
      "pdfPage": "40",
      "printedPage": "35",
      "tableRef": "Figure 3. Public Debt Structure Indicators"
    },
    "omn": {
      "valuePct": 69.4,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Oman: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Oman",
      "reportDate": "2026-01-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/004/002.2026.issue-004-en.xml",
      "pdfPage": "51",
      "printedPage": "45",
      "tableRef": "Annex III. Figure 1. Oman: Public Debt Structure Indicators"
    },
    "pak": {
      "valuePct": 34.7,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Pakistan: Third Review Under the Extended Arrangement Under the Extended Fund Facility and Second Review Under the Resilience and Sustainability Facility Arrangement-Press Release; Staff Report; and Statement by the Executive Director for Pakistan",
      "reportDate": "2026-05-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/101/002.2026.issue-101-en.xml",
      "pdfPage": "49",
      "printedPage": "43",
      "tableRef": "Figure 1. Pakistan: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "pan": {
      "valuePct": 0,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "nfps",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Panama: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Panama",
      "reportDate": "2025-08-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/245/002.2025.issue-245-en.xml",
      "pdfPage": "77",
      "printedPage": "71",
      "tableRef": "Figure 3. Public Debt Structure Indicators, Debt by Currency (Percent of GDP)"
    },
    "per": {
      "valuePct": 42.7,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "nfps",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Peru: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Peru",
      "reportDate": "2026-05-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/113/002.2026.issue-113-en.xml",
      "pdfPage": "46",
      "printedPage": "42",
      "tableRef": "Table 7. Peru: Financial and External Vulnerability Indicators"
    },
    "phl": {
      "valuePct": 31.8,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Philippines: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for the Philippines",
      "reportDate": "2025-12-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/333/002.2025.issue-333-en.xml",
      "pdfPage": "61",
      "printedPage": "55",
      "tableRef": "Figure 3. Philippines: Public Debt Structure Indicators, Debt by Currency (Percent of GDP)"
    },
    "plw": {
      "valuePct": 0,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Republic of Palau: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for the Republic of Palau",
      "reportDate": "2026-01-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/022/002.2026.issue-022-en.xml",
      "pdfPage": "52",
      "printedPage": "46",
      "tableRef": "Annex VIII. Figure 3. Palau: Public Debt Structure Indicators, Debt by Currency (Percent of GDP)"
    },
    "png": {
      "valuePct": 54.9,
      "year": "2025",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Papua New Guinea: Sixth Reviews Under the Extended Arrangement Under the Extended Fund Facility and the Arrangement Under the Extended Credit Facility, Request for a Waiver of Nonobservance of Performance Criterion, and Second Review Under the Resilience and Sustainability Facility Arrangement-Press Release; Staff Report; and Statement by the Executive Director for Papua New Guinea",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/129/002.2026.issue-129-en.xml",
      "pdfPage": "129",
      "printedPage": "18",
      "tableRef": "Table 2. Papua New Guinea: Public Sector Debt Sustainability Framework, Baseline Scenario, 2023–2046"
    },
    "pol": {
      "valuePct": 25.4,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Republic of Poland: 2025 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2026-02-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/025/002.2026.issue-025-en.xml",
      "pdfPage": "48",
      "printedPage": "42",
      "tableRef": "Annex V. Table 3. Poland: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "prt": {
      "valuePct": 0,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Portugal: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Portugal",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/147/002.2026.issue-147-en.xml",
      "pdfPage": "49",
      "printedPage": "45",
      "tableRef": "Figure 1. Portugal: Public Debt Structure Indicators, Debt by Currency (Percent of GDP)"
    },
    "pry": {
      "valuePct": 85,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Paraguay: Fifth Review Under the Policy Coordination Instrument, Request for Modification of a Quantitative Target and Resetting of Reform Targets, Third Review Under the Arrangement Under the Resilience and Sustainability Facility, Rephasing of Reform Measures, and Requests for Extension of the Policy Coordination Instrument and the Resilience and Sustainability Facility Arrangement-Press Release; and Staff Report",
      "reportDate": "2025-07-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/161/002.2025.issue-161-en.xml",
      "pdfPage": "30",
      "printedPage": "26",
      "tableRef": "Table 3. Paraguay: Selected Economic and Social Indicators, Public sector debt by currency"
    },
    "qat": {
      "valuePct": 53.5,
      "year": "2023",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Qatar: 2024 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Qatar",
      "reportDate": "2025-02-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/047/002.2025.issue-047-en.xml",
      "pdfPage": "61",
      "printedPage": "56",
      "tableRef": "Figure IV. 4. Qatar: Public Debt Structure Indicators — Debt by Currency"
    },
    "rou": {
      "valuePct": 48.7,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Romania: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Romania",
      "reportDate": "2025-11-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/294/002.2025.issue-294-en.xml",
      "pdfPage": "41",
      "printedPage": "35",
      "tableRef": "Annex III. Figure 2. Romania: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "rwa": {
      "valuePct": 80.6,
      "year": "2025",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Rwanda: Request for a 38-Month Arrangement Under the Extended Credit Facility; Press Release;  Staff Report; and Statement by the Executive Director for Rwanda",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/139/002.2026.issue-139-en.xml",
      "pdfPage": "95",
      "printedPage": "15",
      "tableRef": "Table 2. Rwanda: Public Sector Debt Sustainability Framework, Baseline Scenario, 2025–46"
    },
    "sau": {
      "valuePct": 42,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Saudi Arabia: 2025 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2025-08-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/223/002.2025.issue-223-en.xml",
      "pdfPage": "79",
      "printedPage": "73",
      "tableRef": "Annex VIII, Figure 3: Saudi Arabia: Public Debt Structure Indicators — Debt by Currency"
    },
    "sdn": {
      "valuePct": 87.7,
      "year": "2020",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "general_government",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Sudan: Enhanced Heavily Indebted Poor Countries (HIPC) Initiative-Decision Point Document",
      "reportDate": "2021-07-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2021/144/002.2021.issue-144-en.xml",
      "pdfPage": "71",
      "printedPage": "9",
      "tableRef": "Table 2. Sudan: Public Sector Debt Sustainability Framework, Baseline Scenario, 2020–2041"
    },
    "sen": {
      "valuePct": 73.7,
      "year": "2022",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Senegal: Requests for an Extended Arrangement Under the Extended Fund Facility, an Arrangement Under the Extended Credit Facility, and an Arrangement Under the Resilience and Sustainability Facility-Press Release; Staff Report; and Statement by the Executive Director for Senegal",
      "reportDate": "2023-07-07",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2023/250/002.2023.issue-250-en.xml",
      "pdfPage": "116",
      "printedPage": "4",
      "tableRef": "Background, paragraph 6"
    },
    "sgp": {
      "valuePct": 0,
      "year": "FY2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Singapore: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Singapore",
      "reportDate": "2025-07-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/192/002.2025.issue-192-en.xml",
      "pdfPage": "66",
      "printedPage": "61",
      "tableRef": "Annex VI. Table 3. Singapore: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "slb": {
      "valuePct": 57.6,
      "year": "2023",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Solomon Islands: 2024 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Solomon Islands",
      "reportDate": "2025-02-25",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/049/002.2025.issue-049-en.xml",
      "pdfPage": "60",
      "printedPage": "3",
      "tableRef": "Text Figure 1. Solomon Islands: Public Debt Composition, 2017–2023"
    },
    "sle": {
      "valuePct": 61.1,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "general_government",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Sierra Leone: First and Second Reviews Under the Extended Credit Facility Arrangement, Request for Waivers of Nonobservance of Performance Criteria-Press Release; and Statement by the Executive Director for Sierra Leone",
      "reportDate": "2026-02-13",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/040/002.2026.issue-040-en.xml",
      "pdfPage": "38",
      "printedPage": "33",
      "tableRef": "Table 9. Sierra Leone: Decomposition of Public Debt and Debt Service by Creditor, 2023–25"
    },
    "slv": {
      "valuePct": 0,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "nfps",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "El Salvador: 2025 Article IV Consultation, First Review Under the Extended Fund Facility, and Request for Waivers of Nonobservance of Performance Criteria, and Modification of Performance Criteria-Press Release; Staff Report; and Statement by the Executive Director for El Salvador",
      "reportDate": "2025-07-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/190/002.2025.issue-190-en.xml",
      "pdfPage": "79",
      "printedPage": "72",
      "tableRef": "Figure 3. El Salvador: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "smr": {
      "valuePct": 0,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Republic of San Marino: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for the Republic of San Marino",
      "reportDate": "2025-11-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/312/002.2025.issue-312-en.xml",
      "pdfPage": "62",
      "printedPage": "56",
      "tableRef": "Annex VI. Figure 2, “Republic of San Marino: Public Debt Structure Indicators” — Debt by Currency"
    },
    "som": {
      "valuePct": 93.9,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "public_sector",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Somalia: Fourth Review Under the Extended Credit Facility Arrangement and Request for Augmentation of Access-Press Release; Staff Report; and Statement by the Executive Director for Somalia",
      "reportDate": "2025-12-16",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/335/002.2025.issue-335-en.xml",
      "pdfPage": "44",
      "printedPage": "40",
      "tableRef": "Table 13. Somalia: Decomposition of Public Debt and Debt Service by Creditor, 2024–2027"
    },
    "srb": {
      "valuePct": 76.7,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Republic of Serbia: Third Review Under the Policy Coordination Instrument; Press Release and Staff Report",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/138/002.2026.issue-138-en.xml",
      "pdfPage": "56",
      "printedPage": "51",
      "tableRef": "Annex III. Figure 3. Serbia: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "ssd": {
      "valuePct": 67.9,
      "year": "FY2022/23 (end-June 2023)",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Republic of South Sudan: 2023 Article IV Consultation, and First and Second Reviews under the Staff-Monitored Program with Board Involvement-Press Release; Staff Report; and Statement by the Executive Director for Republic of South Sudan",
      "reportDate": "2024-06-10",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2024/160/002.2024.issue-160-en.xml",
      "pdfPage": "89",
      "printedPage": "3",
      "tableRef": "Text Table 2. Republic of South Sudan: Decomposition of Public Debt by Creditor, FY 22/23–FY 24/25"
    },
    "stp": {
      "valuePct": 53.1,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "central_government",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Republic of São Tomé and Príncipe: Second Review Under the Extended Credit Facility Arrangement, Requests for Waivers of Nonobservance of Performance Criteria, Modification of Performance Criteria, Extension and Augmentation of the Arrangement, and Financing Assurances Review-Press Release; Staff Report; and Statement by the Executive Director for the Republic of São Tomé and Príncipe",
      "reportDate": "2025-12-23",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/347/002.2025.issue-347-en.xml",
      "pdfPage": "81",
      "printedPage": "5",
      "tableRef": "Text Table 3. São Tomé and Príncipe: Decomposition of Public Debt and Debt Service by Creditor, 2023–26"
    },
    "sur": {
      "valuePct": 87.5,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Suriname: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Suriname",
      "reportDate": "2026-02-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/037/002.2026.issue-037-en.xml",
      "pdfPage": "46",
      "printedPage": "41",
      "tableRef": "Annex III. Figure 3a. Suriname: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "svk": {
      "valuePct": 5.1,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Slovak Republic: 2026 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2026-03-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/065/002.2026.issue-065-en.xml",
      "pdfPage": "48",
      "printedPage": "43",
      "tableRef": "Annex III, Figure 3 — Debt by Currency (Percent of GDP)"
    },
    "svn": {
      "valuePct": 3.8,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Republic of Slovenia: 2025 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2026-01-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/015/002.2026.issue-015-en.xml",
      "pdfPage": "50",
      "printedPage": "44",
      "tableRef": "Annex IV. Figure 3. Public Debt Structure Indicators — Debt by currency (Percent of GDP)"
    },
    "swe": {
      "valuePct": 12.9,
      "year": "2022",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Sweden: 2023 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Sweden",
      "reportDate": "2023-03-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2023/111/002.2023.issue-111-en.xml",
      "pdfPage": "32",
      "printedPage": "27",
      "tableRef": "Annex I. Figure 3. Public Debt Structure Indicators — Debt by Currency"
    },
    "swz": {
      "valuePct": 44,
      "year": "FY2024/25",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Kingdom of Eswatini: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Kingdom of Eswatini",
      "reportDate": "2025-09-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/279/002.2025.issue-279-en.xml",
      "pdfPage": "19",
      "printedPage": "14",
      "tableRef": "Figure 3. Eswatini: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "syc": {
      "valuePct": 54,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Seychelles: 2026 Article IV Consultation, Fifth and Sixth Reviews Under the Arrangement Under the Extended Fund Facility and the Arrangement Under the Resilience and Sustainability Facility, and Request for a Waiver for Nonobservance of a Performance Criterion-Press Release; Staff Report; and Statement by the Executive Director for Seychelles",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/122/002.2026.issue-122-en.xml",
      "pdfPage": "25",
      "printedPage": "18",
      "tableRef": "Annex V. Figure 2. Seychelles: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "tcd": {
      "valuePct": 52.4,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "central_government",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Chad: Request for a Four-Year Arrangement Under the Extended Credit Facility-Press Release; Staff Report; and Statement by the Executive Director for Chad",
      "reportDate": "2025-08-13",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/236/002.2025.issue-236-en.xml",
      "pdfPage": "127",
      "printedPage": "16",
      "tableRef": "Table 2. Chad: Public Sector Debt Sustainability Framework, 2022–45"
    },
    "tgo": {
      "valuePct": 42.2,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Togo: Second Review Under the Arrangement Under the Extended Credit Facility, Requests for Waiver of Nonobservance of a Performance Criterion, Modification of Performance Criteria, Extension of the Arrangement, and Rephasing of Access-Press Release; Staff Report; and Statement by the Executive Director for Togo",
      "reportDate": "2025-07-11",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/178/002.2025.issue-178-en.xml",
      "pdfPage": "114",
      "printedPage": "18",
      "tableRef": "Table 2. Togo: Public Sector Debt Sustainability Framework, Baseline Scenario, 2022–45"
    },
    "tha": {
      "valuePct": 0.8,
      "year": "2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "nfps",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Thailand: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Thailand",
      "reportDate": "2026-02-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/041/002.2026.issue-041-en.xml",
      "pdfPage": "66",
      "printedPage": "60",
      "tableRef": "Figure 3. Thailand: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "tjk": {
      "valuePct": 89.6,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "general_government",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Republic of Tajikistan: 2025 Article IV Consultation and Second Review under the Policy Coordination Instrument and Request for Modification of a Reform Target-Press Release; Staff Report; and Statement by the Executive Director for Republic of Tajikistan",
      "reportDate": "2025-07-08",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/169/002.2025.issue-169-en.xml",
      "pdfPage": "142",
      "printedPage": "25",
      "tableRef": "Table 2. Tajikistan: Public Sector Debt Sustainability Framework, Baseline Scenario, 2022–2045"
    },
    "tls": {
      "valuePct": 100,
      "year": "2020",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Timor-Leste: 2021 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Timor-Leste",
      "reportDate": "2021-07-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2021/152/002.2021.issue-152-en.xml",
      "pdfPage": "73",
      "printedPage": "16",
      "tableRef": "Table 2. Timor-Leste: Public Sector Debt Sustainability Framework Baseline Scenario, 2018–2041"
    },
    "ton": {
      "valuePct": 85.7,
      "year": "FY2024",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "general_government",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Tonga: 2025 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2025-11-10",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/293/002.2025.issue-293-en.xml",
      "pdfPage": "86",
      "printedPage": "15",
      "tableRef": "Table 2. Tonga: Public Sector Debt Sustainability Framework, Baseline Scenario, FY2022–2045"
    },
    "tto": {
      "valuePct": 31,
      "year": "FY2025",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Trinidad and Tobago: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Trinidad and Tobago",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/120/002.2026.issue-120-en.xml",
      "pdfPage": "54",
      "printedPage": "50",
      "tableRef": "Annex III. Sovereign Risk and Debt Sustainability Assessment, paragraph 2"
    },
    "tur": {
      "valuePct": 50.8,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Republic of Türkiye: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for the Republic of Türkiye",
      "reportDate": "2026-02-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/043/002.2026.issue-043-en.xml",
      "pdfPage": "74",
      "printedPage": "69",
      "tableRef": "Annex VII. Figure 2. Türkiye: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "tuv": {
      "valuePct": 68.3,
      "year": "2022",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "public_sector",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Tuvalu: 2023 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Tuvalu",
      "reportDate": "2023-07-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2023/267/002.2023.issue-267-en.xml",
      "pdfPage": "69",
      "printedPage": "19",
      "tableRef": "Table 1. Tuvalu: External Debt Sustainability Framework, Baseline Scenario, 2020–2043"
    },
    "tza": {
      "valuePct": 65.9,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "central_government",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "United Republic of Tanzania: Staff Report for the 2025 Article IV Consultation, Fifth Review Under the Extended Credit Facility Arrangement, Modification of Performance Criteria, and Second Review Under the Resilience and Sustainability Facility Arrangement-Press Release; Staff Report; and Statement by the Executive Director for the United Republic of Tanzania",
      "reportDate": "2025-07-03",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/163/002.2025.issue-163-en.xml",
      "pdfPage": "125",
      "printedPage": "4",
      "tableRef": "Text Table 2. United Republic of Tanzania: Decomposition of Public Debt and Debt Service by Creditor, 2024–2026"
    },
    "uga": {
      "valuePct": 58.9,
      "year": "FY2022/23",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "general_government",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Uganda: 2024 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Uganda",
      "reportDate": "2024-09-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2024/290/002.2024.issue-290-en.xml",
      "pdfPage": "88",
      "printedPage": "4",
      "tableRef": "Table 1. Uganda: Decomposition of Public Debt and Debt Service by Creditor, FY2022/23–FY2024/25"
    },
    "ukr": {
      "valuePct": 74.1,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Ukraine: Request for an Extended Arrangement Under the Extended Fund Facility and Cancellation of the Current Arrangement-Press Release; Staff Report; Supplementary Information; and Statement by the Alternate Executive Director for Ukraine",
      "reportDate": "2026-02-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/058/002.2026.issue-058-en.xml",
      "pdfPage": "103",
      "printedPage": "98",
      "tableRef": "Table AVII. 3. Ukraine: Public Debt Structure Indicators—Baseline Scenario (pre-restructuring), “Debt by Currency (Percent of GDP)”"
    },
    "ury": {
      "valuePct": 45.7,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "nfps",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Uruguay: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Uruguay",
      "reportDate": "2025-10-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/287/002.2025.issue-287-en.xml",
      "pdfPage": "69",
      "printedPage": "63",
      "tableRef": "Table 3. Uruguay: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "usa": {
      "valuePct": 0,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "United States: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for the United States",
      "reportDate": "2026-04-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/076/002.2026.issue-076-en.xml",
      "pdfPage": "63",
      "printedPage": "57",
      "tableRef": "Annex II. Figure 3. United States: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "uzb": {
      "valuePct": 90.6,
      "year": "2025",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Republic of Uzbekistan: 2026 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2026-06-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/152/002.2026.issue-152-en.xml",
      "pdfPage": "105",
      "printedPage": "16",
      "tableRef": "Table 2. Uzbekistan: Public Sector Debt Sustainability Framework, Baseline Scenario, 2023–2046"
    },
    "vct": {
      "valuePct": 71.3,
      "year": "2023",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "public_sector",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "St. Vincent and the Grenadines: 2024 Article IV Consultation-Press Release and Staff Report",
      "reportDate": "2024-07-22",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2024/239/002.2024.issue-239-en.xml",
      "pdfPage": "79",
      "printedPage": "3",
      "tableRef": "Text Table 2"
    },
    "vnm": {
      "valuePct": 34.3,
      "year": "2022",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Vietnam: 2023 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Vietnam",
      "reportDate": "2023-09-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2023/338/002.2023.issue-338-en.xml",
      "pdfPage": "75",
      "printedPage": "70",
      "tableRef": "Figure 3. Vietnam: Public Debt Structure Indicators"
    },
    "vut": {
      "valuePct": 70,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "central_government",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Vanuatu: 2025 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2025-09-25",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/277/002.2025.issue-277-en.xml",
      "pdfPage": "50",
      "printedPage": "43",
      "tableRef": "Annex VI, Current State of Debt and Funding, paragraph 1"
    },
    "wsm": {
      "valuePct": 83.3,
      "year": "FY2024",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Samoa: 2024 Article IV Consultation-Press Release; and Staff Report",
      "reportDate": "2025-01-31",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2025/032/002.2025.issue-032-en.xml",
      "pdfPage": "95",
      "printedPage": "22",
      "tableRef": "Table 2. Samoa: Public Sector Debt Sustainability Framework, Baseline Scenario, 2022–2045"
    },
    "kos": {
      "valuePct": 6.7,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "general_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "Republic of Kosovo: 2026 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for the Republic of Kosovo",
      "reportDate": "2026-04-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/079/002.2026.issue-079-en.xml",
      "pdfPage": "47",
      "printedPage": "42",
      "tableRef": "Annex II, Figure 2. Kosovo: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "zaf": {
      "valuePct": 10.5,
      "year": "2024",
      "framework": "MAC_SRDSF",
      "definitionBasis": "currency",
      "debtPerimeter": "central_government",
      "isProxy": false,
      "proxySource": null,
      "confidence": "medium",
      "reportTitle": "South Africa: 2025 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for South Africa",
      "reportDate": "2026-02-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/034/002.2026.issue-034-en.xml",
      "pdfPage": "58",
      "printedPage": "54",
      "tableRef": "Figure 3. South Africa: Public Debt Structure Indicators — Debt by Currency (Percent of GDP)"
    },
    "zmb": {
      "valuePct": 62.2,
      "year": "2024",
      "framework": "LIC_DSF",
      "definitionBasis": "currency",
      "debtPerimeter": "public_sector",
      "isProxy": false,
      "proxySource": null,
      "confidence": "high",
      "reportTitle": "Zambia: Sixth Review Under The Extended Credit Facility Arrangement, Request for a waiver of Nonobservance of a Quantitative Performance Criterion, and Financing Assurances Review-Press Release; Staff Report; and Statement by the Executive Director for Zambia",
      "reportDate": "2026-02-02",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2026/021/002.2026.issue-021-en.xml",
      "pdfPage": "114",
      "printedPage": "6",
      "tableRef": "Table 1. Zambia: Public and Publicly Guaranteed Debt Stock—Creditor Composition and Contracted Debt Service"
    },
    "zwe": {
      "valuePct": 97.2,
      "year": "2020",
      "framework": "LIC_DSF",
      "definitionBasis": "residency",
      "debtPerimeter": "public_sector",
      "isProxy": true,
      "proxySource": "external_share_residency",
      "confidence": "medium",
      "reportTitle": "Zimbabwe: 2022 Article IV Consultation-Press Release; Staff Report; and Statement by the Executive Director for Zimbabwe",
      "reportDate": "2022-04-01",
      "publicationUrl": "https://elibrary.imf.org/view/journals/002/2022/112/002.2022.issue-112-en.xml",
      "pdfPage": "110",
      "printedPage": "13",
      "tableRef": "Table 2. Zimbabwe: Public Sector Debt Sustainability Framework, Baseline Scenario, 2018–2041"
    }
  }
}
